import PageHero from '@/components/shared/PageHero';
import ContactInfoSection from '@/components/home/ContactInfoSection';
import useSEO from '@/hooks/useSEO';

export default function ContactPage() {
    useSEO({
        title: 'Contact Us',
        description:
            'Get in touch with VVVSI Trust — Head Office in Puducherry (Kirumampakkam) and Branch Office in Chennai (Valasaravakkam). Reach us at +91 9751443139 or info@vvvsi.com for programs, partnerships or media queries.',
    });
    return (
        <div data-testid="contact-page">
            <PageHero
                eyebrow="Contact Us"
                title="We'd love to hear from you."
                subtitle="For programs, partnerships, media queries or general questions — reach out."
            />
            <ContactInfoSection />
        </div>
    );
}
